<ms-crm-promotion-container *ngIf="crmBannerPromotions.length" [promotions]="crmBannerPromotions"></ms-crm-promotion-container>
<ms-meeting [races]="vm.races" (fixtureClick)="onFixtureClick($event)"></ms-meeting>
